import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'
import _imports_1 from '@/assets/google.svg'
import _imports_2 from '@/assets/apple-sign-in.svg'


const _withScopeId = n => (_pushScopeId("data-v-6bcc5afc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sign-in-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logotyp"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Here we go!"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Already have an account?", -1))
const _hoisted_5 = {
  key: 1,
  class: "sign-in-wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logotyp"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Alright, before proceeding you need to create an account", -1))
const _hoisted_8 = { class: "providers" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "providerImg",
  src: _imports_1,
  alt: "google"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sign in with Google", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "appleImg",
  src: _imports_2,
  alt: "apple"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.regPassMail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.register && $setup.register(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              placeholder: "Email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.register_form.email) = $event)),
              required: ""
            }, null, 512), [
              [
                _vModelText,
                $setup.register_form.email,
                void 0,
                { lazy: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              placeholder: "Password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register_form.password) = $event)),
              required: ""
            }, null, 512), [
              [
                _vModelText,
                $setup.register_form.password,
                void 0,
                { lazy: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              placeholder: "Repeat password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register_form.repeatPassword) = $event)),
              required: ""
            }, null, 512), [
              [
                _vModelText,
                $setup.register_form.repeatPassword,
                void 0,
                { lazy: true }
              ]
            ]),
            _hoisted_3
          ], 32),
          _hoisted_4,
          _createVNode(_component_router_link, { to: "/signin" }, {
            default: _withCtx(() => [
              _createTextVNode("Sign in")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!$setup.regPassMail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "provider",
              onClick: _cache[4] || (_cache[4] = 
          () => {
            $setup.signIn('google');
          }
        )
            }, _hoisted_11),
            _createElementVNode("div", {
              class: "apple",
              onClick: _cache[5] || (_cache[5] = 
          () => {
            $setup.signIn('apple');
          }
        )
            }, _hoisted_13)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "email",
      onClick: _cache[6] || (_cache[6] = 
      () => {
        $setup.regPassMail ? ($setup.regPassMail = false) : ($setup.regPassMail = true);
      }
    )
    }, " Or sign up with " + _toDisplayString(!$setup.regPassMail ? "your email" : "our providers"), 1)
  ], 64))
}